export const NODE_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT

export const SERVER_URL = process.env.NEXT_PUBLIC_SERVER_URL
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL
export const YANDEX_CAPTCHA_KEY = process.env.NEXT_PUBLIC_YANDEX_CAPTCHA_KEY
export const PERSONAL_API_URL = process.env.NEXT_PUBLIC_PERSONAL_API_URL
export const PRODUCT_ID_URL_PREFIX = `productID`
export const PRODUCT_URL = `/products/${PRODUCT_ID_URL_PREFIX}`
export const API_URL = `${SERVER_URL}/api`
export const FILES_URL = SERVER_URL

/**
 * Direct Credit contour. It must match the contour the backend creates credit orders in —
 * a guid issued by the test gateway is unknown to the production widget and vice versa.
 */
export const DIRECT_CREDIT_MODE = process.env.NEXT_PUBLIC_DIRECT_CREDIT_MODE === 'dev' ? 'dev' : 'prod'

export const YANDEX_API_KEY = process.env.NEXT_PUBLIC_YANDEX_API_KEY
export const DADATA_API_KEY = process.env.NEXT_PUBLIC_DADATA_API_KEY
